var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95826 11.9663C2.68062 11.2439 3.66036 10.8381 4.68193 10.8381H11.319C12.3405 10.8381 13.3203 11.2439 14.0426 11.9663C14.765 12.6886 15.1708 13.6684 15.1708 14.6899V16.3492C15.1708 16.6437 14.932 16.8825 14.6375 16.8825C14.3429 16.8825 14.1042 16.6437 14.1042 16.3492V14.6899C14.1042 13.9513 13.8107 13.2428 13.2884 12.7205C12.7661 12.1982 12.0576 11.9048 11.319 11.9048H4.68193C3.94325 11.9048 3.23483 12.1982 2.71251 12.7205C2.19018 13.2428 1.89674 13.9513 1.89674 14.6899V16.3492C1.89674 16.6437 1.65796 16.8825 1.36341 16.8825C1.06886 16.8825 0.830078 16.6437 0.830078 16.3492V14.6899C0.830078 13.6684 1.2359 12.6886 1.95826 11.9663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00045 1.9485C6.46223 1.9485 5.21526 3.19547 5.21526 4.73369C5.21526 6.2719 6.46223 7.51887 8.00045 7.51887C9.53866 7.51887 10.7856 6.2719 10.7856 4.73369C10.7856 3.19547 9.53866 1.9485 8.00045 1.9485ZM4.1486 4.73369C4.1486 2.60637 5.87313 0.881836 8.00045 0.881836C10.1278 0.881836 11.8523 2.60637 11.8523 4.73369C11.8523 6.86101 10.1278 8.58554 8.00045 8.58554C5.87313 8.58554 4.1486 6.86101 4.1486 4.73369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhiteIcon);
export default __webpack_public_path__ + "static/media/userWhiteIcon.7d1c1dbf79894d4b07344a09180cacc5.svg";
export { ForwardRef as ReactComponent };